import React, { useEffect, useState } from 'react';

import BasicInfo from '../profile/component/basicInfo';

import Address from '../profile/component/address';

import BankDetails from '../profile/component/bankDetails';

import Document from '../profile/component/document';

import PickUp from '../profile/component/pickUpLocation';

import Loader from '../../component/loader';

import axios from 'axios';

import Cookies from 'js-cookie';

import { decrpt } from '../../component/encryption';

const ProfileDetails = () => {
  const [sellerProfile, setSellerProfile] = useState(null);

  const [error, setError] = useState('');

  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);

  const [pickupError, setPickupError] = useState(null);

  const [pickUpModal, setPickUpModel] = useState(false);

  const [fetchStates, setFetchStates] = useState([]);

  const [fetchDistricts, setFetchDistricts] = useState([]);

  const [fetchCities, setFetchCities] = useState([]);

  const [selectedStateId, setSelectedStateId] = useState(null);

  const [basicInfoModal, setBasicInfoModal] = useState(false);

  /* ---------------- SAFE FALLBACK OBJECTS ---------------- */
  const bankDetail = sellerProfile?.bank_detail ?? {};

  const businessDetails = sellerProfile?.business_details ?? {};

  /* ---------------- STATES ---------------- */

  const [basicUpdate, setBasicUpdate] = useState({
    name: '',
    email: '',
    phone: '',
    alt_mobile: '',
    gender: '',
    dob: ''
  });

  const [bankDetails, setBankDetails] = useState({
    bank_name: '',
    branch: '',
    ac_no: '',
    ifsc: '',
    name: ''
  });

  const [sellerDocument, setSellerDocument] = useState({
    pan_image: '',
    trade_lic_image: '',
    gst_image: '',
    pan: '',
    trade_lic_no: '',
    gst: ''
  });

  const [address, setAddress] = useState({
    state: '',
    district: '',
    city: '',
    pin: '',
    street: '',
    land_mark: '',
    address: ''
  });

  const [filePreview, setFilePreview] = useState({
    trade_lic_no: '',
    trade_lic_image: '',
    gst: '',
    gst_image: '',
    pan: '',
    pan_image: ''
  });

  const [bussinesDetails, setBussinesDetails] = useState({
    business_name: '',
    state: '',
    city: '',
    district: '',
    pin: '',
    street: '',
    land_mark: '',
    address: '',
    mobile: '',
    alt_mobile: '',
    business_email: '',
    business_description: '',
    business_category: ''
  });

  const handleBasicUpdate = (e) => {
    const { name, value } = e.target;
    setBasicUpdate((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /* ---------------- API HELPERS ---------------- */

  const authHeader = () => {
    const token = decrpt(Cookies.get('s_l'));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  /* ---------------- FETCH PROFILE ---------------- */

  const fetchData = async () => {
    try {
      setLoader(true);
      authHeader();
      const res = await axios.get('/seller/profile');
      if (res.data.success) {
        setSellerProfile(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  /* ---------------- UPDATE HANDLERS ---------------- */

  const updatePersonal = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      authHeader();
      const res = await axios.post(
        '/seller/profile/personal/details/update',
        basicUpdate
      );
      if (res.data.success) {
        setSellerProfile(res.data.data);
        setBasicInfoModal(false);
      }
    } catch (err) {
      setError(err?.response?.data?.errors);
    } finally {
      setLoader(false);
    }
  };

  const updateBankDetails = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      authHeader();
      const res = await axios.post(
        '/seller/profile/bank/details/update',
        bankDetails
      );
      if (res.data.success) {
        setSellerProfile(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const updateAddress = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      authHeader();
      const res = await axios.post(
        '/seller/profile/address/update',
        address
      );
      if (res.data.success) {
        setSellerProfile(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const updateBussinessDetails = async () => {
    try {
      setLoader(true);
      authHeader();
      const res = await axios.post(
        '/seller/profile/business/details/update',
        bussinesDetails
      );
      if (res.data.success) {
        setPickUpModel(false);
        setSellerProfile((prev) => ({
          ...prev,
          business_details: res.data.data.business_details
        }));
      }
    } catch (err) {
      setPickupError(err?.response?.data?.errors);
      setPickUpModel(true);
    } finally {
      setLoader(false);
    }
  };

  const updateDocument = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      authHeader();
      const formData = new FormData();
      formData.append('id', sellerProfile?.id);
      if (sellerDocument.pan_image instanceof File) {
        formData.append('pan_image', sellerDocument.pan_image);
      }
      if (sellerDocument.trade_lic_image instanceof File) {
        formData.append('trade_lic_image', sellerDocument.trade_lic_image);
      }
      if (sellerDocument.gst_image instanceof File) {
        formData.append('gst_image', sellerDocument.gst_image);
      }
      formData.append('pan', sellerDocument.pan);
      formData.append('trade_lic_no', sellerDocument.trade_lic_no);
      formData.append('gst', sellerDocument.gst);

      const res = await axios.post('/seller/registration/document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (res.data.success) {
        setSellerProfile(res.data.data);
        setShow(false);
      }
    } catch (err) {
      setError(err?.response?.data?.errors);
    } finally {
      setLoader(false);
    }
  };

  /* ---------------- FETCH STATE / CITY ---------------- */

  const fetchState = async () => {
    const res = await axios.get('/seller/masters/state/list');
    if (res.data.success) setFetchStates(res.data.data);
  };

  const fetchDistrict = async (state_id) => {
    if (!state_id) return;
    setSelectedStateId(state_id);
    const data = { state_id: state_id };
    const res = await axios.post('/seller/district/dropdown/list', data);
    if (res.data.success) setFetchDistricts(res.data.data);
  };

  const fetchCity = async (district_id) => {
    if (!selectedStateId || !district_id) return;
    const res = await axios.get(
      `/seller/masters/city/list/${selectedStateId}/${district_id}`
    );
    if (res.data.success) setFetchCities(res.data.data);
  };

  const handleState = (state_id) => {
    setAddress((prev) => ({ ...prev, state: state_id, district: '', city: '' }));
    fetchDistrict(state_id);
  };

  const handleDistrict = (district_id) => {
    setAddress((prev) => ({ ...prev, district: district_id, city: '' }));
    fetchCity(district_id);
  };

  /* ---------------- EFFECTS (SAFE) ---------------- */

  useEffect(() => {
    fetchData();
    fetchState();
  }, []);

  useEffect(() => {
    setBasicUpdate({
      name: sellerProfile?.name ?? '',
      email: sellerProfile?.email ?? '',
      phone: sellerProfile?.mobile ?? '',
      alt_mobile: sellerProfile?.alt_mobile ?? '',
      gender: sellerProfile?.gender ?? '',
      dob: sellerProfile?.dob ?? ''
    });

    setAddress({
      state: sellerProfile?.state_id ?? '',
      district: sellerProfile?.district_id ?? '',
      city: sellerProfile?.city_id ?? '',
      pin: sellerProfile?.pin ?? '',
      street: sellerProfile?.street ?? '',
      land_mark: sellerProfile?.land_mark ?? '',
      address: sellerProfile?.address ?? ''
    });

    if (sellerProfile?.district_id) {
      setSelectedStateId(sellerProfile.state_id);
      fetchDistrict(sellerProfile.state_id);
    }

    if (sellerProfile?.state_id && sellerProfile?.district_id) {
      fetchCity(sellerProfile.district_id);
    }

    setBankDetails({
      bank_name: bankDetail?.bank_name ?? '',
      branch: bankDetail?.branch ?? '',
      ac_no: bankDetail?.ac_no ?? '',
      ifsc: bankDetail?.ifsc ?? '',
      name: bankDetail?.name ?? ''
    });

    setSellerDocument({
      pan_image: '',
      trade_lic_image: '',
      gst_image: '',
      pan: sellerProfile?.pan ?? '',
      trade_lic_no: sellerProfile?.trade_lic_no ?? '',
      gst: sellerProfile?.gst ?? ''
    });

    setBussinesDetails({
      business_name: businessDetails?.business_name ?? '',
      state: businessDetails?.state ?? '',
      city: businessDetails?.city ?? '',
      district: businessDetails?.district ?? '',
      pin: businessDetails?.pin ?? '',
      street: sellerProfile?.street ?? '',
      land_mark: sellerProfile?.land_mark ?? '',
      address: sellerProfile?.address ?? '',
      mobile: sellerProfile?.mobile ?? '',
      alt_mobile: sellerProfile?.alt_mobile ?? '',
      business_email: sellerProfile?.business_email ?? '',
      business_description:
        businessDetails?.business_description ?? '',
      business_category:
        businessDetails?.business_category ?? ''
    });
  }, [sellerProfile]);

  /* ---------------- RENDER ---------------- */

  if (loader) return <Loader />;

  return (
    <>
      <BasicInfo
        sellerProfile={sellerProfile}
        basicUpdate={basicUpdate}
        handleBasicUpdate={handleBasicUpdate}
        updatePersonal={updatePersonal}
        basicInfoModal={basicInfoModal}
        setBasicInfoModal={setBasicInfoModal}
        error={error}
      />

      <div className="section">
        <div className="row mb-3">
          <div className="col-md-6">
            <Address
              sellerProfile={sellerProfile}
              address={address}
              setAddress={setAddress}
              updateAddress={updateAddress}
              fetchStates={fetchStates}
              fetchDistricts={fetchDistricts}
              fetchCities={fetchCities}
              handleState={handleState}
              handleDistrict={handleDistrict}
            />
          </div>

          <div className="col-md-6">
            <BankDetails
              sellerProfile={sellerProfile}
              bankDetails={bankDetails}
              setBankDetails={setBankDetails}
              updateBankDetails={updateBankDetails}
            />
          </div>
        </div>

        <PickUp
          sellerProfile={businessDetails}
          updateBussinessDetails={updateBussinessDetails}
          bussinesDetails={bussinesDetails}
          setBussinesDetails={setBussinesDetails}
          pickUpModal={pickUpModal}
          setPickUpModel={setPickUpModel}
          pickupError={pickupError}
        />

        <Document
          sellerProfile={sellerProfile}
          sellerDocument={sellerDocument}
          setSellerDocument={setSellerDocument}
          filePreview={filePreview}
          setFilePreview={setFilePreview}
          error={error}
          setError={setError}
          show={show}
          setShow={setShow}
          updateDocument={updateDocument}
        />
      </div>
    </>
  );
};

export default ProfileDetails;
